/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamLoungeResponseData } from './genericApiResponseOralExamLoungeResponseData';
import type { GenericApiResponseOralExamLoungeResponseMessage } from './genericApiResponseOralExamLoungeResponseMessage';
import type { GenericApiResponseOralExamLoungeResponsePagination } from './genericApiResponseOralExamLoungeResponsePagination';
import type { GenericApiResponseOralExamLoungeResponseError } from './genericApiResponseOralExamLoungeResponseError';

export interface GenericApiResponseOralExamLoungeResponse {
  data?: GenericApiResponseOralExamLoungeResponseData;
  message?: GenericApiResponseOralExamLoungeResponseMessage;
  pagination?: GenericApiResponseOralExamLoungeResponsePagination;
  error?: GenericApiResponseOralExamLoungeResponseError;
  statusCode?: number;
}
